import { Button, Modal, PropagationNotice, WriteError } from '@shared/ui';

import {
    platformDefaultConfirmCopy,
    type PlatformDefaultChange,
} from './platform-default-confirm-copy';

/**
 * The prod-write confirmation on the platform-default toggles (NOXSCRUM-1529).
 *
 * `pending` is `null` while closed. Setting it opens the dialog *instead of*
 * writing — the toggle's `onChange` no longer calls `mutate` directly, this
 * dialog's confirm button does, in the parent (`FlagDetailPage`), which is
 * where the actual `SetDefaultInput` gets built. Cancelling needs no
 * rollback: the mutation was never started, so the toggle simply renders the
 * value it already had.
 */
export function PlatformDefaultConfirmDialog({
    flagKey,
    pending,
    isPending,
    error,
    onCancel,
    onConfirm,
}: {
    flagKey: string;
    pending: PlatformDefaultChange | null;
    isPending: boolean;
    error: Error | null;
    onCancel: () => void;
    onConfirm: () => void;
}) {
    const copy = pending ? platformDefaultConfirmCopy(flagKey, pending) : undefined;

    return (
        <Modal
            open={pending !== null}
            onClose={() => {
                if (!isPending) onCancel();
            }}
            dismissable={!isPending}
            title={copy?.title ?? ''}
            description={copy?.description}
            footer={
                <>
                    <Button variant="ghost" onClick={onCancel} disabled={isPending}>
                        Cancel
                    </Button>
                    <Button disabled={isPending} onClick={onConfirm}>
                        {isPending ? 'Saving…' : 'Confirm'}
                    </Button>
                </>
            }
        >
            <div className="flex flex-col gap-4">
                {error && <WriteError error={error} />}
                <PropagationNotice />
            </div>
        </Modal>
    );
}
